/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { Logo } from "frontend/src/components/Logo"

const LogoSection = ({ logos, children = "bekannt aus", ...rest }) => {
  return (
    <div
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        m: 0,
        px: 6,
        mb: [9, 12],
        maxHeight: [20, 25, 40],
        overflow: "hidden",
        alignSelf: "flex-end",
      }}
      {...rest}
    >
      <h2
        sx={{
          variant: "text.h3",
          m: 0,
          mr: 8,
          whiteSpace: "nowrap",
          display: ["none", "none", "block"],
        }}
      >
        {children}
      </h2>
      {logos.map((name, i) => (
        <Logo
          name={name}
          key={name}
          height={[20, 25, 40]}
          forceColor="white"
          sx={{
            position: "relative",
            zIndex: 1,
            mr: i !== logos.length ? 8 : 0,
          }}
        />
      ))}
    </div>
  )
}

export { LogoSection }
